import type { SxProps, Theme } from "@mui/material/styles";

export const headerBlock: SxProps<Theme> = {
  display: "flex",
  flexDirection: "column",
  gap: 1.25,
};

export const backLink: SxProps<Theme> = {
  display: "inline-flex",
  alignItems: "center",
  gap: 0.75,
  fontSize: "0.8125rem",
  color: "text.secondary",
  textDecoration: "none",
  width: "fit-content",
  transition: "color 0.2s ease",
  "&:hover": {
    color: "primary.main",
  },
};
